const ANDROID = 'ANDROID';
const IOS = 'IOS';
const WEB = 'WEB';

export default {
  ANDROID,
  IOS,
  WEB,
};
